var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceyellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83301 9.33333C4.83301 9.33333 5.83301 10.6667 7.49967 10.6667C9.16634 10.6667 10.1663 9.33333 10.1663 9.33333M9.49967 6H9.50634M5.49967 6H5.50634M14.1663 8C14.1663 11.6819 11.1816 14.6667 7.49967 14.6667C3.81778 14.6667 0.833008 11.6819 0.833008 8C0.833008 4.3181 3.81778 1.33333 7.49967 1.33333C11.1816 1.33333 14.1663 4.3181 14.1663 8ZM9.83301 6C9.83301 6.18409 9.68377 6.33333 9.49967 6.33333C9.31558 6.33333 9.16634 6.18409 9.16634 6C9.16634 5.8159 9.31558 5.66666 9.49967 5.66666C9.68377 5.66666 9.83301 5.8159 9.83301 6ZM5.83301 6C5.83301 6.18409 5.68377 6.33333 5.49967 6.33333C5.31558 6.33333 5.16634 6.18409 5.16634 6C5.16634 5.8159 5.31558 5.66666 5.49967 5.66666C5.68377 5.66666 5.83301 5.8159 5.83301 6Z",
    stroke: "#FDB022",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceyellow);
export default __webpack_public_path__ + "static/media/faceyellow.6e774bc68594921da67bc3f5586c16be.svg";
export { ForwardRef as ReactComponent };